/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupportTicketControllerAddCommentRequestEvidenceUrlsInner } from './supportTicketControllerAddCommentRequestEvidenceUrlsInner';
import { NewSupportTicketReferenceLinksInner } from './newSupportTicketReferenceLinksInner';


/**
 * (tsType: Partial<SupportTicket>, schemaOptions: { partial: true })
 */
export interface SupportTicketPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    title?: string;
    description?: string;
    status?: SupportTicketPartial.StatusEnum;
    priority?: SupportTicketPartial.PriorityEnum;
    moduleId?: string;
    companyId?: string;
    businessUnitId?: string;
    departmentId?: string;
    additionalMetadata?: object;
    evidenceUrls?: Array<SupportTicketControllerAddCommentRequestEvidenceUrlsInner>;
    referenceLinks?: Array<NewSupportTicketReferenceLinksInner>;
    assignedTo?: number | null;
    firstAssignedOn?: string;
    firstResponseOn?: string;
    resolvedOn?: string;
    closedOn?: string;
    responseDueOn?: string;
    resolutionDueOn?: string;
    reopenedCount?: number;
}
export namespace SupportTicketPartial {
    export type StatusEnum = 'open' | 'in_progress' | 'resolved' | 'closed';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        InProgress: 'in_progress' as StatusEnum,
        Resolved: 'resolved' as StatusEnum,
        Closed: 'closed' as StatusEnum
    };
    export type PriorityEnum = 'low' | 'medium' | 'high' | 'critical';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Medium: 'medium' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Critical: 'critical' as PriorityEnum
    };
}


